
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Créer un site Internet pour un restaurant – Exemples, Prix et Délais",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Site Internet ou landing page, un restaurant doit assurer sa visibilité sur Internet. Cet article vous explique tout !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Créer un site Internet pour un restaurant – Exemples, Prix et Délais",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Site Internet ou landing page, un restaurant doit assurer sa visibilité sur Internet. Cet article vous explique tout !",
        },
      ],
    };
  },
};
